import React, { useEffect, useState } from "react";
import "../../../../style/alerts.scss";
import { useTranslation } from "react-i18next";
import HtmlTooltip from "@mui/material/Tooltip";
interface IProps {
  assigned: boolean;
  startTime: number;
  saleFrom: number;
  status: string;
  waitList: boolean;
  waitListPosition: number;
}

const SingleAlertsExercise: React.FC<IProps> = ({
  assigned,
  startTime,
  saleFrom,
  status,
  waitList,
  waitListPosition,
}) => {
  const { t } = useTranslation();

  const [future, setFuture] = useState<boolean>(true);

  useEffect(() => {
    const date = new Date();
    const saleFromDate = new Date(startTime);
    if (date < saleFromDate) {
      setFuture(false);
    }
    //eslint-disable-next-line
  }, []);

  return (
    <>
      {assigned && waitList === false && (
        <b className="alert-center alert alert-green alert-small ">{t("jestes_zapisany")}</b>
      )}
      <HtmlTooltip
        placement="bottom-start"
        title={
          <>
            <article
              className="tooltip-description"
              dangerouslySetInnerHTML={{
                __html:
                  "Zapisanie się na listę rezerwową spowoduje, że zapiszemy Cie do kolejki osób oczekujących na rezerwacje. Jeśli ktoś zrezygnuje, to zapiszemy Ciebie.",
              }}
            ></article>
          </>
        }
      >
        <div>
          {waitList === true && (
            <b className="alert-center alert alert-yellow alert-small ">
              {t("lista_rezerwowa")} ({waitListPosition})
            </b>
          )}
        </div>
      </HtmlTooltip>
      {!future && status === "G" && (
        <b className="alert alert-yellow alert-small alert-center">{t("sprzedaz_nieaktywna")}</b>
      )}
    </>
  );
};

export default SingleAlertsExercise;
